<template>
  <div class="IndexComponents">
    <div class="IndexComponents__main mt-1">
      <div class="pt-1 pb-0 IndexComponents__flex">
        <div class="IndexComponents_left pl-1 IndexComponents_color">
          {{ $t(IndexLeft_title) }}
        </div>
        <div
          class="IndexComponents_right IndexComponents__center"
          style="padding: 0.3rem 0.5rem"
          @click="getpath"
        >
          {{ $t(IndexRight_title) }}
          <div>
            <img
              :src="IndexRight_img"
              alt=""
              style="width: 20px; height: 20px; padding-left: 5px"
            />
          </div>
        </div>
      </div>
      <div class="padding-1">
        <slot name="Miracle"></slot>
        <ComButton
          v-if="btnShow"
          :btnText="$t(btnTitle)"
          type="primary"
          @click="handleClick"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IndexComponents",
  props: {
    IndexLeft_title: {
      type: String,
      default: "",
    },
    IndexRight_title: {
      type: String,
      default: "",
    },
    IndexRight_img: {
      type: String,
      default: "",
    },
    btnTitle: {
      type: String,
      default: "立即认购",
    },
    btnShow: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$emit("handleSure");
    },
    getpath() {
      this.$emit("Path");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>